import { api } from './api.service';

export interface IOyanaAddresses {
  cep: string;
  city: string;
  state: string;
  country?: string;
  address: string;
  addressNumber?: number | string | null;
  addressComplement: string;
  addressReference: string;
  neighborhood: string;
  isResidentialAddress?: boolean;
}

export interface IOyanaResponse {
  id: string;
  cpf: string;
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber: string;
  birthDate: string;
  nickName: string;
  fullName: string;
  profileImageThumbnail: string;
  addresses: Array<IOyanaAddresses>;
}

export interface ISingInOTPRequest {
  oyanaid: string;
  code: string;
}

export interface IOyanaAddressResult {
  address: IOyanaAddresses;
  needConfirmAddress: boolean;
}

export const oyana = api.injectEndpoints({
  endpoints: build => ({
    getPersonalData: build.mutation<IOyanaResponse, { token: string }>({
      query: ({ token }) => ({
        url: `/portal/v1/me`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    }),

    meSoftLogin: build.mutation<IOyanaResponse, { token: string }>({
      query: ({ token }) => ({
        url: `/portal/v1/me/softlogin`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    })
  })
});

export const { useGetPersonalDataMutation, useMeSoftLoginMutation } = oyana;
